import { render } from "./UpArrow.vue?vue&type=template&id=4b884968&scoped=true"
import script from "./UpArrow.vue?vue&type=script&lang=js"
export * from "./UpArrow.vue?vue&type=script&lang=js"

import "./UpArrow.vue?vue&type=style&index=0&id=4b884968&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\abelh\\.projects\\koko_v1\\koko_v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b884968"]])

export default __exports__